import * as React from 'react';
import { HashTagModel } from '../../../models';
import Controller, { IAbstractDashboardControllerProps } from '../common/CommonDashboardController';
import View from './HashtagsTableView';

interface IHashTagsViewControllerState {
    hashtags: HashTagModel[]
    limit: number
    skip: number
    dataCount: number
    searchText: string
}

class HashTagsViewController<P, S> extends Controller<P, S & IHashTagsViewControllerState> {

    public static defaultProps: Partial<IAbstractDashboardControllerProps> = {
        title: 'Хэштеги'
    }

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            hashtags: [],
            skip: 0,
            limit: 25,
            dataCount: 0,
            searchText: ''
        } as any;
    }

    public async fia_componentWillMount() {
        this.setState({ loading: true });
        await this.loadHashTags();
    }

    public async onNewHashTag(name: string) {
        this.setState({ loading: true });
        const newHashTag = new HashTagModel();
        newHashTag.name = name.toLowerCase();
        newHashTag.popularity = 0;
        await newHashTag.save();
        this.loadHashTags();
    }

    public async loadHashTags(s?: number, l?: number) {
        const { limit, skip } = this.state;
        const hashtags = await HashTagModel.loadHashtags(s || s === 0 ? s : skip, l ? l : limit);
        const dataCount = await HashTagModel.getHashtagsCount();
        this.setState({ hashtags, dataCount, loading: false });
    }

    public async onSaveEditedTag(index: number) {
        this.setState({ loading: true });
        const { hashtags } = this.state;
        await hashtags[index].save()
        await this.loadHashTags();
    }

    public async onHashTagsDelete(hashtags: HashTagModel[]) {
        await this.setState({ loading: true });
        await HashTagModel.destroyAll(hashtags)
        await this.loadHashTags();
    }

    public async onSearchHashTags(sText: string, l?: number, s?: number) {
        const { limit, skip } = this.state;
        this.setState({ searchText: sText });
        const hashtags = await HashTagModel.searchHashTag(sText, l || l === 0 ? l : limit, s || s === 0 ? s : skip) as HashTagModel[];
        const dataCount = await HashTagModel.searchHashTag(sText, l || l === 0 ? l : limit, s || s === 0 ? s : skip, true) as number;
        this.setState({ dataCount, hashtags, loading: false });
    }

    public async onChangePage(page: number) {
        const { limit, searchText } = this.state;
        const currentSkip = page * limit;
        this.setState({ skip: currentSkip, loading: true });
        if (searchText) {
            await this.onSearchHashTags(searchText, limit, currentSkip);
        } else {
            await this.loadHashTags(currentSkip);
        }
    }

    public async onChangeRowPerPage(rPP: number) {
        const { searchText } = this.state;
        this.setState({ limit: rPP, loading: true });
        if (this.state.searchText) {
            await this.onSearchHashTags(searchText, rPP, this.state.skip);
        } else {
            await this.loadHashTags(this.state.skip, rPP);
        }
    }

    public dashboard_render(): JSX.Element {
        const { loading, hashtags, limit, dataCount } = this.state
        return <View
            accessAvailable={this.accessAvailable}
            onConfirmDelete={(ps: HashTagModel[]) => this.onHashTagsDelete(ps)}
            model={hashtags}
            loading={loading}
            onSaveEditedTag={(index: number) => this.onSaveEditedTag(index)}
            onSearchHashTags={(s: string) => this.onSearchHashTags(s)}
            rowsPerPage={limit}
            dataCount={dataCount}
            defaultHashTagsValues={hashtags.map(h => ({ name: h.name, popularity: h.popularity }))}
            onChangePage={(cP: number) => this.onChangePage(cP)}
            onNewHashTag={(name: string) => this.onNewHashTag(name)}
            onChangeRowsPerPage={(rPP: number) => this.onChangeRowPerPage(rPP)}
        />
    }
}

export default HashTagsViewController;



// WEBPACK FOOTER //
// ./src/app/dashboard/hashtags/HashTagsTableViewController.tsx